import type { CmmdRuntimeDiagnosticsSnapshot } from "@cmmd-forge/contracts";

import type { DesktopDiagnosticsTarget } from "./DiagnosticsDesktopTabs.logic";
import { DiagnosticsCanonicalRuntimeSnapshot } from "./DiagnosticsCanonicalRuntimeSnapshot";
import { DiagnosticsEvidenceNotice } from "./DiagnosticsEvidenceNotice";
import {
  DiagnosticsCard,
  DiagnosticsMetrics,
  DiagnosticsSection,
  StatusPill,
  formatTimestamp,
} from "./DiagnosticsPanelPrimitives";

export function DiagnosticsDesktopRuntime({
  target,
  snapshot,
  diagnosticsError,
  diagnosticsPending,
}: {
  readonly target: DesktopDiagnosticsTarget;
  readonly snapshot: CmmdRuntimeDiagnosticsSnapshot | undefined;
  readonly diagnosticsError: string | undefined;
  readonly diagnosticsPending: boolean;
}) {
  return (
    <>
      <DiagnosticsSection
        title={target.label}
        id="diagnostics-target"
        description="A Forge Desktop server, as CMMD's authorized device registry sees it."
        action={
          target.presence === "online" ? (
            <StatusPill label="CMMD registry: online" tone="ready" />
          ) : (
            <StatusPill label="CMMD registry: offline" tone="muted" />
          )
        }
      >
        <div className="px-3 pb-2 sm:px-4">
          <DiagnosticsEvidenceNotice evidence="registry" />
        </div>
        <DiagnosticsCard>
          <DiagnosticsMetrics
            metrics={[
              { label: "Runtime", value: target.runtimeId, mono: true },
              { label: "Device", value: String(target.deviceId), mono: true },
              { label: "Platform", value: target.platform },
              { label: "Observed", value: formatTimestamp(target.observedAt) },
              { label: "Source", value: "CMMD authorized device registry" },
            ]}
          />
        </DiagnosticsCard>
      </DiagnosticsSection>
      <DiagnosticsCanonicalRuntimeSnapshot
        snapshot={snapshot}
        error={diagnosticsError}
        pending={diagnosticsPending}
      />
    </>
  );
}
